import dayjs from "dayjs"

const completeFormTaskBoiler = {
    timeFormat: "YYYY-MM-DD HH:mm:ss",
    distributionGroups: [
        {
            PortalDynamicFormDistributionGroupId: 1,
            Name: "ProfitCenter"
        },
        {
            PortalDynamicFormDistributionGroupId: 2,
            Name: "Company"
        },
        {
            PortalDynamicFormDistributionGroupId: 3,
            Name: "Employee"
        },
        {
            PortalDynamicFormDistributionGroupId: 4,
            Name: "State"
        }
    ],
    distributionPoints: [
        {
            PortalDynamicFormDistributionPointId: 1,
            Name: "Mobile"
        },
        {
            PortalDynamicFormDistributionPointId: 2,
            Name: "Web"
        },
        {
            PortalDynamicFormDistributionPointId: 3,
            Name: "*"
        }
    ],
    generateCompletedTask: (helper, user, CustomFormDataId) => {
        let rb = {
            DynamicFormWorkFlowId: helper.DynamicFormWorkFlowId,
            CustomFormId: helper.CustomFormId,
            CustomFormDataId: CustomFormDataId,
            PortalDynamicFormDistributionGroupId: helper.PortalDynamicFormDistributionGroupId,
            PortalDynamicFormDistributionPointId: helper.PortalDyanmicFormDistributionPointId,
            FormDistributeTo: completeFormTaskBoiler.getPointOrGroup("distributionGroups", helper.PortalDynamicFormDistributionGroupId),
            DistributionPoint: completeFormTaskBoiler.getPointOrGroup("distributionPoints", helper.PortalDyanmicFormDistributionPointId),
            DistributionPointName: user.userName,
            Value: user.userId,
            DueDateUTC: helper.DueDateUTC,
            CompletedDateUTC: dayjs().utc().format(completeFormTaskBoiler.timeFormat),
            CompletedBy: user.userId,
            NeedsSupervisorApproval: helper.NeedsSupervisorApproval,
            SupervisorId: helper.SupervisorId,
            SupervisorApproved: helper.SupervisorApproved,
            SupervisorDateUTC: helper.SupervisorDateUTC,
            NeedsHRApproval: helper.NeedsHRApproval,
            HRApproved: helper.HRApproved,
            CreatedDateUTC: helper.CreatedDateUTC,
            CreatedBy: helper.CreatedBy,
            ModifyDate: dayjs().utc().format(completeFormTaskBoiler.timeFormat),
            ModifiedBy: user.userId,
            DeletedDateUTC: helper.DeletedDateUTC,
            DeletedBy: helper.DeletedBy,
            DisabledDateUTC: helper.DisabledDateUTC,
            DisabledBy: helper.DisabledBy,
        }
        return rb
    },
    getPointOrGroup: (referenceItem, id) => {
        //@ts-ignore
        const list = completeFormTaskBoiler[referenceItem]
        for (let i = 0; i < list.length; i++) {
            const item = list[i]
            const keys = Object.keys(list[i])
            const key1 = keys[0]
            const key2 = keys[1]
            if (item[key1] === id) {
                return item[key2]
            }
        }
        return null
    }
}

export default completeFormTaskBoiler